import { mapActions, mapGetters, mapMutations } from "vuex";
import store from "@/store";

export default {
    name: "home-work-rules",
    data() {
        return {
            hasLoadData: false,
        };
    },
    created() {
        this.changeHeader({
            show: true,
            title: this.$t("homeWorkRules"),
            parentRoute: {
                name: "courses-main",
                params: { item: this.$route.params.item },
            },
        });

        this.fetchData({
            ...this.$route.params,
        })
            .then(() => {
                this.checkStatusTest();
                this.hasLoadData = true;
            })
            .catch((error) => {
                if (error.response.status === 403) {
                    // this.$toasted.error(error.response.data.error.message_key)
                    try {
                        this.$router.push({
                            name: "courses-main",
                            params: { item: this.$route.params.item },
                        });
                    } catch (e) {
                        console.log(e);
                    }
                }
            });
    },
    beforeRouteEnter(to, from, next) {
        if (from) {
            store.commit(`coursesHomeWork/CHANGE_FROM_ROUTE_INFO`, {
                name: from.name,
                params: from.params,
            });
        }
        next();
    },
    beforeRouteLeave(to, from, next) {
        if (!to.path.includes(`home-work/${this.$route.params.testId}`)) {
            this.setItem(null);
        }
        next();
    },
    computed: {
        ...mapGetters({
            isLoading: "coursesHomeWork/isLoading",
            currentItem: "coursesHomeWork/currentItem",
            routeFromInfo: "coursesHomeWork/routeFromInfo",
        }),
        convertSecondsToMinutes() {
            return Math.ceil(this.currentItem.duration / 60);
        },
    },
    methods: {
        ...mapActions({
            fetchData: "coursesHomeWork/GET_LIST_ITEM",
        }),
        ...mapMutations({
            changeHeader: "coursesHomeWork/CHANGE_HEADER",
            setItem: "coursesHomeWork/SET_ITEM",
            setQuestion: "coursesHomeWork/SET_CURRENT_QUESTION",
            setReportResult: "coursesHomeWork/SET_REPORT_RESULT",
            changeRouteFromInfo: "coursesHomeWork/CHANGE_FROM_ROUTE_INFO",
        }),
        declensionWord(count, type) {
            let titles = [this.$t(`${type}1`), this.$t(`${type}2`), this.$t(`${type}3`)];
            let cases = [2, 0, 1, 1, 1, 2];
            return titles[
                count % 100 > 4 && count % 100 < 20
                    ? 2
                    : cases[count % 10 < 5 ? count % 10 : 5]
            ];
        },
        start(param) {
            this.$router.push({
                name: `home-work-${param}`,
                params: {
                    ...this.$route.params,
                },
            });
        },
        checkStatusTest() {
            if (this.currentItem.userHomeWork.data.hasOwnProperty("status")) {
                switch (this.currentItem.userHomeWork.data.status) {
                    case "processing": {
                        this.start("questions");
                        break;
                    }
                    case "canceled": {
                        break;
                    }
                    case "new": {
                        if (this.currentItem.type === "text") {
                            this.start("questions");
                        }

                        break;
                    }
                    case "on_checking": {
                        try {
                            this.$router.push({
                                name: "home-work-check",
                                params: {
                                    ...this.$route.params,
                                },
                            });
                        } catch (e) {
                            console.log(e);
                        }
                        break;
                    }
                    case "on_approval": {
                        try {
                            this.$router.push({
                                name: "home-work-check",
                                params: {
                                    ...this.$route.params,
                                },
                            });
                        } catch (e) {
                            console.log(e);
                        }
                        break;
                    }
                    case "retake": {
                        if (this.currentItem.type === "text") {
                            this.start("questions");
                        }
                        break;
                    }
                    default: {
                        try {
                            this.$router.push({
                                name: "home-work-report",
                                params: {
                                    ...this.$route.params,
                                },
                            });
                        } catch (e) {
                            console.log(e);
                        }
                        break;
                    }
                }
            }
        },
        goBack() {
            this.$router.push({
                name: this.routeFromInfo.name,
                params: this.routeFromInfo.params,
            });
        },
    },
    beforeDestroy() {
        console.log("destroy header");
        this.setQuestion(null);
        this.setReportResult(null);
        this.changeHeader({
            show: false,
            title: "",
            currentTime: "",
            availableTime: "",
            parentRoute: "",
        });
    },
};
